// export const timesheetType = [
//     {
//         // day shift
//         label: "日勤 ",
//         value: "0",
//     },
//     {
//         // night shift
//         label: "夜勤",
//         value: "1",
//     },
//     {
//         // Day shift and ngiht shift
//         label: "日勤と夜勤",
//         value: "2",
//     },
//     {
//         // Holiday Work
//         label: "休日出勤",
//         value: "3",
//     },
//     {
//         // Paid Time Off
//         label: "有給休暇",
//         value: "4",
//     },
//     {
//         // Half-day work
//         label: "半日出勤",
//         value: "5",
//     },
//     {
//         // Absence
//         label: "欠勤",
//         value: "6",
//     },
//     {
//         // Legal Holiday
//         label: "公休日",
//         value: "7",
//     },
// ];

export const timesheetType = [
    {
        // day shift
        label: "日勤 ",
        value: "0",
    },
    {
        // Holiday Work
        label: "休日出勤",
        value: "3",
    },
    {
        // night shift
        label: "夜勤",
        value: "1",
    },
    {
        // Day shift and ngiht shift
        label: "日勤からの夜勤",
        value: "2",
    },
    {
        // night shift and day shift
        label: "夜勤からの日勤",
        value: "8",
    },
    {
        // Half-day work
        label: "半日有給",
        value: "5",
    },
    {
        // behind time- tardiness
        label: "遅刻",
        value: "9",
    },
    {
        // leaving early - early leave
        label: "早退",
        value: "10",
    },

];

// The client wants these options to be unavailable for new timesheet records, but they should still be visible for existing records.
export const removedTimesheetTitleLabels = ["遅刻", "早退", "夜勤からの日勤"];

export const timesheetSelectableType = timesheetType.filter(
    (item) => !removedTimesheetTitleLabels.includes(item.label.trim())
);

export const timesheetSpanOptions = [
    { label: "日勤", value: 0 },
    { label: "休日出勤", value: 3 },
    { label: "夜勤", value: 1 },
    { label: "日勤からの夜勤", value: 2 },
    { label: "夜勤からの日勤", value: 8 },
    { label: "半日有給", value: 5 },
    { label: "遅刻", value: 9 },
    { label: "早退", value: 10 },
];

export const timesheetSelectableSpanOptions = timesheetSpanOptions.filter(
    (item) => !removedTimesheetTitleLabels.includes(item.label)
);

const selectableTimesheetTitleSet = new Set(
    timesheetSelectableType.map((item) => item.label.trim())
);

export const isSelectableTimesheetTitle = (title?: string): boolean => {
    if (!title) return false;
    return selectableTimesheetTitleSet.has(title.trim());
};

